import css from "standard/css";

const style = css`
  .liveCreate {
    align-items: center;
    background-color: var(--color-pure-white);
    border-radius: var(--border-radius-sm);
    box-shadow: var(--shadow-level-1);
    border: none;
    cursor: pointer;
    text-decoration: none;
    color: var(--color-ocean);
    display: flex;
    flex-direction: column;
    font-size: var(--font-size-sm);
    gap: var(--spacing_inset-nano);
    justify-content: center;
    font-family: var(--font-family-highlight);
    margin: 0 auto;
    max-width: 458.65px;
    padding: var(--spacing_inset-md) var(--spacing_inset-giant);
    transition: box-shadow 0.3s ease, background-color 0.2s ease;
    width: 100%;
  } 

  .liveCreate:hover {
    background-color: var(--color-orange);
    box-shadow: var(--shadow-solid);
    color: var(--color-pure-white);

    .liveCreate svg {
      color: var(--color-pure-white);
    }
  }
`;

export default style;
